import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormControl, NgModel} from '@angular/forms';

@Component({
  selector: 'app-text-area',
  templateUrl: './text-area.component.html',
  styleUrl: './text-area.component.scss'
})
export class TextAreaComponent {
  
  @Input() label         ?: string;
  @Input() placeholder   ?: string;
  @Input() value         ?: string;
  @Input() rows          ?: string;
  @Input() cols          ?: string;
  @Input() type          ?: string;
  @Input() className     ?: string;
  @Input() starIcon      ?: any;
  @Input() control      !: FormControl;
  @Input() ngModel       ?: NgModel;
  @Input() borderColor   : boolean = false;
  @Output() focusEvent   : EventEmitter<FocusEvent> = new EventEmitter<FocusEvent>();
  @Output() blurEvent     : EventEmitter<FocusEvent> = new EventEmitter<FocusEvent>();

  constructor() {
    this.control = new FormControl('');
  }

  onFocus(event: FocusEvent) {
    this.focusEvent.emit(event);
  }

  onBlur(event: FocusEvent) {
    this.blurEvent.emit(event);
  }
}
